import React, { useState, useRef } from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

export default function FlipCardElement({ element, onActions }) {
  const [flipped, setFlipped] = useState(false);
  const flipFiredRef = useRef(false);

  const {
    frontTitle = "",
    frontText = "",
    frontBg = "#1e3a5f",
    frontTextColor = "#ffffff",
    frontImage,
    backTitle = "",
    backText = "",
    backBg = "#0d5c3a",
    backTextColor = "#ffffff",
    backImage,
    backButtonLabel = i18n.t("InteractiveScenario.Default.Continue") || "Devam",
    backActions = [],
    flipActions = [],
  } = element;

  const handleFlip = () => {
    if (flipped) {
      // Going back to front — allow flipActions to fire again next time
      flipFiredRef.current = false;
    }
    setFlipped((f) => !f);
  };

  const handleTransitionEnd = (e) => {
    if (e.propertyName !== "transform") return;
    if (flipped && flipActions.length > 0 && !flipFiredRef.current) {
      flipFiredRef.current = true;
      onActions(flipActions);
    }
  };

  return (
    <div
      className={`sce-flipcard${flipped ? " sce-flipcard--flipped" : ""}`}
      onClick={handleFlip}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleFlip();
        }
      }}
      aria-pressed={flipped}
    >
      <div className="sce-flipcard__inner" onTransitionEnd={handleTransitionEnd}>
        {/* Front */}
        <div
          className="sce-flipcard__face sce-flipcard__face--front"
          style={{ background: frontBg, color: frontTextColor }}
        >
          {frontImage && <img src={frontImage} alt="" className="sce-flipcard__img" />}
          {frontTitle && <h3 className="sce-flipcard__title">{frontTitle}</h3>}
          {frontText && <p className="sce-flipcard__text">{frontText}</p>}
          <span className="sce-flipcard__hint">
            {i18n.t("InteractiveScenario.Label.ClickToFlip") || "Çevirmek için tıkla"}
          </span>
        </div>

        {/* Back */}
        <div
          className="sce-flipcard__face sce-flipcard__face--back"
          style={{ background: backBg, color: backTextColor }}
          onClick={(e) => e.stopPropagation()}
        >
          {backImage && <img src={backImage} alt="" className="sce-flipcard__img" />}
          {backTitle && <h3 className="sce-flipcard__title">{backTitle}</h3>}
          {backText && <p className="sce-flipcard__text">{backText}</p>}
          {backActions.length > 0 && (
            <button
              type="button"
              className="sce-btn sce-btn--primary sce-flipcard__action-btn"
              onClick={(e) => {
                e.stopPropagation();
                onActions(backActions);
              }}
            >
              {backButtonLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
